module.exports = __webpack_public_path__ + "img/9788954422727.a744f5f5.jpg";